export enum InteractionMode {
    CONTACTLESS,
    TOUCH,
    QR
}
